export const gtagService = {
  trackEvent: (
    event: string,
    eventProperties: Record<string, unknown> = {},
  ): void => {
    if (!window.dataLayer) {
      console.warn('missing Google Tag Manager dataLayer');

      return;
    }

    window.dataLayer.push({
      event,
      ...eventProperties,
    });
  },
};
